import React from "react";

const EmptyProductTableList = ({ hasProducts, search }) => {
  const copy =
    hasProducts && search
      ? "No products match your search"
      : "No remaining products to add to pricing table. Create more to add.";

  return (
    <li className="flex items-center bt bb b--black-05 ph3 pv4 w-100 justify-between h-100 bh--inset bg-white">
      <div className="pa3 f7 ba br2 w-100 lh-copy hairline-1">{copy}</div>
    </li>
  );
};

export default EmptyProductTableList;
